export default __webpack_public_path__ + "static/media/pasport-incorrect.4cd35c85.png";